import React, { useEffect, useState } from 'react';
import { AMBASSADOR_EVENT, pendingSignupCode, clearSignupCode, redeemAmbassador } from '../ambassadorApi';
import { useLanguage } from '../contexts/LanguageContext';

/** Survives the auth screen unmounting as Firebase signs a new user in. */
export default function SignupAmbassador({ user }) {
  const { language } = useLanguage();
  const ar = language === 'ar';
  const [code, setCode] = useState(() => pendingSignupCode(user));
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const refresh = () => setCode(pendingSignupCode(user));
    refresh();
    window.addEventListener(AMBASSADOR_EVENT, refresh);
    return () => window.removeEventListener(AMBASSADOR_EVENT, refresh);
  }, [user]);
  useEffect(() => {
    if (!code || !user) return undefined;
    let mounted = true;
    setError('');
    redeemAmbassador(user, code, 'Signup').then(() => clearSignupCode()).catch((err) => {
      if (mounted) setError(err.message);
    });
    return () => { mounted = false; };
  }, [user, code, attempt]);
  if (!code) return null;
  return (
    <aside className="js-ambassador-banner" role="status">
      {error ? <>
        <p>{ar ? 'تم إنشاء حسابك، لكن لم يتم تطبيق رمز السفير.' : 'Your account is ready, but your ambassador code hasn’t been applied.'} {error}</p>
        <button type="button" onClick={() => setAttempt((n) => n + 1)}>{ar ? 'إعادة المحاولة' : 'Retry code'}</button>
        <button type="button" onClick={clearSignupCode}>{ar ? 'سأضيف الرمز لاحقاً من ملفي الشخصي' : 'I’ll add a code later in Profile'}</button>
      </> : <p>{ar ? 'جارٍ تطبيق رمز السفير…' : 'Applying your ambassador code…'}</p>}
    </aside>
  );
}
